import { decode } from "jsonwebtoken";
import { each, get, isEmpty } from "lodash";
import React from "react";
import { getCompanyToken } from "../apis/auth";
import DataComponent from "../components/DataComponent";
import {
  TASK_STATUS_LIST, TASK_TYPES
} from "../constants/TASK";
import store from "../store";
import {
  SET_TASK
} from "../store/task/actionTypes";

export const getTaskLabel = (task) => {

  const taskStatus = getTaskStatus(task);
  if (taskStatus.errorCount > 0) {
    alert('ERROR_COUNT 발행 utils/task.js 확인');
  }

  let label = '';
  let color = taskStatus.resultStatus.color;
  if (
    taskStatus.myStatus.status !== 'pending' &&
    taskStatus.taskStatus.status !== 'denied' &&
    taskStatus.taskStatus.status !== 'canceled' &&
    taskStatus.totalCount > taskStatus.approvedCount
  ) {
    label += `${taskStatus.approvedCount}/${taskStatus.totalCount} `;
    color = 'warning';
  }
  label += taskStatus.resultStatus.label;

  return <DataComponent field={
    {
      type: 'badge',
      color,
      label
    }
  }
  />;
};

// task  요청 팝업 type이 없는 경우 목록 노출
export const taskRequest = (type, options, mode = 'create') => {

  setTask({
    type,
    isOpen: true,
    mode,
    ...options
  });
};

// task  요청 팝업 상세
export const taskDetail = async (task = {}, options) => {

  //console.log('[task util] task : ', task);
  const type = get(task, 'type');
  const targetWorkIdx = get(task, 'targetWorkIdx');
  const taskIdx = get(task, 'myTask.idx', get(task, 'tasks[0].idx',));
  const approvalTargetIdx = task.approvalTargetIdx;
  setTask({
    type,
    isOpen: true,
    mode: 'detail',
    targetIdx: targetWorkIdx,
    taskIdx,
    approvalTargetIdx,
    ...options
  });
};


export const setTask = (options = {
  isOpen: false,
  type: null,
  targetIdx: null,
  taskIdx: null,
  mode: null
}) => {
  store.dispatch({
    type: SET_TASK,
    payload: {
      ...options
    }
  });
};


export const getTaskStatusByStatus = (status) => {
  const target = TASK_STATUS_LIST.find(task => task.status === status);
  return target;
};

export const getTaskByType = (type) => {
  return TASK_TYPES.find(task => task.type === type);
};

export const getTaskStatus = (task) => {
  // const employee = store.getState().Profile.employee
  const token = getCompanyToken();
  const me = decode(token);

  // pending 대기중
  // in_progress 진행중
  // complete 승인됨
  // denied 반려됨
  // isCancel => 오로지 대기중일 때만 가능하다
  /**
   * @description
   * isCancel => 담당자: 승인된 항목 / 근태의 경우 이벤트 발생일 이전만 가능
   * isMyCancel -> 요청자: 승인되지 않은 항목만 취소 가능
   * */
  let isStatusConfirm = false;
  let taskStatus = 'pending';
  let myStatus = 'pending';
  let pendingCount = 0;
  let approvedCount = 0;
  let canceledCount = 0;
  let errorCount = 0;
  let totalCount = 0;
  let isHandover = false;
  let isHandoverToMe = false;
  let isMyApprove = false;
  let isMyCancel = false;
  let isCancel = false;
  let isRequester = (task.requesterEmpIdx || task?.approvalTarget.requesterEmpIdx) === me.employeeIdx;
  let isMyApprovalTask = false;
  const approvals = get(task, 'approvals', get(task, 'approvalTarget.approvals', []));

  each(approvals, ({ approvalHandover, approverEmployee = {}, status, type }) => {
    let isMe = false;
    let _employee = approverEmployee || {};
    // 결제자만 확인
    if (approvalHandover) {
      isHandover = true;
      _employee = approvalHandover.targetEmployee;
    }
    if (me.employeeIdx === _employee.idx || me.employeeIdx === approverEmployee.idx) {
      isMe = true;
      // 내 상태
      myStatus = type === 'reference' ? type : status;
      isMyApprovalTask = true;

      if (approvalHandover) {
        isHandoverToMe = true;
      }
    }
    if (!isStatusConfirm && type === 'approver') {
      switch (status) {
        // 반려되면 확정
        case "denied":
          taskStatus = "denied";
          isStatusConfirm = true;
          break;
        case "approved":
          approvedCount += 1;
          break;
        // // 취소되면 확정
        case "canceled":
          taskStatus = "canceled";
          isStatusConfirm = true;
          break;
        case "pending":
          pendingCount += 1;
          if (isMe) isMyApprove = true;
          break;
        default:
          // 이도저도 아닌거 나올수 있기때문에..일단..
          errorCount += 1;
          break;
      }
      // 총 결제 해야 하는 사람 수
      totalCount += 1;
    }
  });

  // 취소는 신청자가 직접 신청한것
  if (!isStatusConfirm) {
    if (task.status === "canceled" || task?.approvalTarget?.status === "canceled") {
      taskStatus = "canceled";
      myStatus = "canceled";
      isMyApprove = false;
    } else if (totalCount === pendingCount) {
      taskStatus = "pending";
      if (task?.approvalTarget?.requesterEmpIdx === me.employeeIdx) {
        isMyCancel = true;
      };
    } else if (totalCount === approvedCount) {
      taskStatus = "complete";
    } else {
      taskStatus = 'in_progress';
      if (task?.approvalTarget?.requesterEmpIdx === me.employeeIdx) {
        isMyCancel = true;
      };
    }
  }

  // 내가 담당자면서, 승인된 할일인지
  if (isMyApprovalTask && taskStatus === "complete" && myStatus !== "reference") {
    isCancel = true;
  }
  return {
    myStatusText: myStatus, // 테스크에 대한 내 상태
    taskStatusText: taskStatus, // 실제 테스크 상태
    isHandoverToMe, // 내가 위임받은것인지
    isMyApprove, // 내가 결제 하는 것 인지?
    isCancel, // 담당자의 취소 가능 여부
    isMyCancel, // 요청자의 취소 가능 여부
    myStatus: TASK_STATUS_LIST.find(t => t.status === myStatus), // 나의 상태
    taskStatus: TASK_STATUS_LIST.find(t => t.status === taskStatus), // 테스크 상태
    resultStatus: TASK_STATUS_LIST.find(t => t.status === (isStatusConfirm ? 'denied' : isMyApprove ? myStatus : taskStatus)), // 결과용 반려있으면 반려 아니면 내 상태
    pendingCount, // 대기 수
    approvedCount, // 승인 수
    canceledCount, // 취소 수
    errorCount,  // 에러!!!!!!!!!!!
    totalCount,  // 전체 수
    isHandover,  // 위임된건지?
    isRequester,
  };
};


// 고도화 필요
export const taskListFields = [{
  title: "상태",
  key: "status",
  align: "left",
  onValue: (_data, _field, task) => {
    return getTaskLabel(task);
  },
  width: 88,
},
{
  title: "유형",
  key: "type",
  align: "left",
  onValue: (data) => {
    const target = getTaskByType(data) || {};
    return target.label;
  },
  width: 145,
},
{
  title: "티켓 명",
  align: "left",
  key: "title",
  type: 'ellipsis',
  onClick: (data) => {
    //console.log(data);
  }
},
{
  title: "발행일",
  type: 'date',
  key: "createdTime",
  sort: "desc",
  width: 130,
},
{
  title: "작성자",
  align: "right",
  key: "requesterEmpIdx",
  type: 'profile',
  width: 180,
},
];

export const isMyApprove = (task) => {
  if (isEmpty(task)) return false;
  const taskStatus = getTaskStatus(task);
  return taskStatus.isMyApprove;
};
export const isMyCancel = (task) => {
  if (isEmpty(task)) return false;
  const taskStatus = getTaskStatus(task);
  return taskStatus.isMyCancel;
};

export const isCancel = (task) => {
  if (isEmpty(task)) return false;
  const taskStatus = getTaskStatus(task);
  return taskStatus.isCancel;
};